



























































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import ContractAddForm from './contractAddForm.vue'
import contractAddTypeModal from './contractAddTypeModal.vue'
@Component({
    name:'contractSpecialList',
    components: {
        ContractAddForm,
        contractAddTypeModal
    }
})
export default class ContractSpecialList extends AbpBase  {
    initData:any = {
        column:{   //自定义显示列
            visible:false,
            dropdownCheckAllGroup:[],
            indeterminate:false,
            checkAll:true, //是否全选 true:全 false:不
            dropdownCheckAllList:[],//自定义列的列表
        },
        searchData: {
            SignYear: null,
            BelongOrgId: null,
            ContractType: null,
            Keyword: null
        },
        dicData: {},
        tableData: {
            title: [
            {
                type: 'selection',
                width: 60,
                align: 'center',
                fixed: 'left'
            },
            {
                title: '合同编号',
                key: 'contractCode',
                width: 150,
                align: 'center',
                fixed: 'left'
            },{
                title: '合同名称',
                key: 'contractName',
                align: 'center',
                minWidth: 300,
                fixed: 'left',
                render:(h:any, params:any) => {
                        return h('a', {
                            on:{
                                click:() => {
                                    this.ToDetail(params.row);
                                }
                            }
                        },params.row.contractName)
                }
            },
            // {
            //     title: '登记审核状态',
            //     key: 'auditStatusDesc',
            //     width: 150,
            //     align: 'center'
            // },
            {
                title: '所属部门',
                key: 'belongOrg',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.belongOrg ? params.row.belongOrg.displayName : '')
                    ])
                }
            },{
                title: '二级部门',
                key: 'secondBelongOrg',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.secondBelongOrg ? params.row.secondBelongOrg.displayName : '')
                    ])
                }
            },{
                title: '签订单位',
                key: 'signUnit',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.signUnit ? params.row.signUnit.unitName : '')
                    ])
                }
            },{
                title: '业主单位',
                key: 'ownerUnit',
                width: 150,
                align: 'center'
            },{
                title: '资金来源',
                key: 'fundsSourceDesc',
                width: 150,
                align: 'center'
            },{
                title: '合同金额(万元)',
                key: 'contractAmountFormat',
                width: 150,
                align: 'center'
            },{
                title: '项目类别',
                key: 'projectCatalog',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.projectCatalog ? params.row.projectCatalog.catalogName : '')
                    ])
                }
            },{
                title: '项目负责人',
                key: 'projectLeader',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.contractProjectLeader ? params.row.contractProjectLeader.name : '')
                    ])
                }
            },{
                title: '经办人',
                key: 'agentUser',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.agentUser ? params.row.agentUser.name : '')
                    ])
                }
            },{
                title: '合同登记时间',
                key: 'creationTime',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.creationTime ? params.row.creationTime.substring(0, 10) : '')
                    ])
                }
            },{
                    title: '标注',
                    key: 'contractLabelDesc',
                    width: 150,
                    align: 'center',
                    className:'bz-cell',
                    render:(h:any,params:any)=>{
                        return h('Dropdown',  [
                            h('div', {
                                class: {
                                    member_operate_div: true
                                }
                            }, [
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    }
                                }, [
                                    h('span', params.row.contractLabelDesc?params.row.contractLabelDesc:'无'),
                                    h('Icon', { })
                                ])
                            ]),
                            h('DropdownMenu', {
                                slot: 'list'
                            }, [
                            h('DropdownItem', {
                                props: {
                                    name: 'edit'
                                }
                            }, [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.initData.label.contractIds.push(params.row.id);
                                            this.initData.label.labelValue = 1;
                                            this.saveLabel();
                                        }
                                    }
                                    }, '正式合同'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                    },
                                    on: {
                                        click: () => {
                                            this.initData.label.contractIds.push(params.row.id);
                                            this.initData.label.labelValue = 2;
                                            this.saveLabel()
                                        }
                                    }
                                    }, '非正式合同')
                                ])
                            ])
                        ])
                    }
                }],
            content: [],
            loading: true,
            newTitle:[],
            currentIndex:2,
        },
        label:{
            model:false,
            labelValue:null,
            contractIds:[],//标注选中的合同id
        },
        addModal: {
            typeIsShow: false,
            mainIsShow: false,
            specialIsShow: false,
            btnLoading: true
        },
        showContractLabel:false,
        tabsBool:true
    }
    dropdownHandleOpen () { //自定义显示列显示隐藏
        this.initData.column.visible = !this.initData.column.visible;
    }
    dropdownHandleCheckAll(){  //自定义列全选
        this.initData.column.dropdownCheckAllGroup = [];
        if (this.initData.column.indeterminate) {
            this.initData.column.checkAll = false;
        } else {
            this.initData.column.checkAll = !this.initData.column.checkAll;
        }
        this.initData.column.indeterminate = false;
        if (this.initData.column.checkAll) {
            this.initData.tableData.title.forEach((item:any,index:any) => {
                if(index != 0){
                    this.initData.column.dropdownCheckAllGroup.push(item.key)
                }
            });
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                return item.isVisiblity = true;
            } )
        } else {
            this.initData.column.dropdownCheckAllGroup = [];
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                return item.isVisiblity = false;
            } )
        }
    }
    dropdownCheckAllGroupChange(res:any){  //自定义列单选
        if (res.length === this.initData.column.dropdownCheckAllList.length) {
            this.initData.column.indeterminate = false;
            this.initData.column.checkAll = true;
        } else if (res.length > 0) {
            this.initData.column.indeterminate = true;
            this.initData.column.checkAll = false;
        } else {
            this.initData.column.indeterminate = false;
            this.initData.column.checkAll = false;
        }
        //获取得到的值
        this.initData.column.dropdownCheckAllList.map( (item:any) => {
            let bool:any = false;
            res.forEach( (val:any) => {
                if(item.fieldEnName == val){
                    bool = true;
                }
            } )
            if(!bool){
                return item.isVisiblity = false;
            }else{
                return item.isVisiblity = true;
            }
        } )
    }
    async saveDropdownColumn(){//保存列
        await Ajax.post('/api/services/app/UserHabits/SaveSpecialContractLedgerAsync',this.initData.column.dropdownCheckAllList);
        await this.$store.dispatch('session/GetCurrentLoginInformations');
        await this.setDropdownCheckAllList();
        this.changeColumn();
        this.initData.column.visible = false;
    }
    setDropdownCheckAllList(){//设置初始化的列
        this.initData.column.dropdownCheckAllGroup = [];
        if(this.initData.tableData.title.length-1 != this.$store.state.session.userHabits.ledger.specialContractLedger.length) {
            this.initData.tableData.title.forEach((item:any,index:any) => {
                if(index != 0){
                    this.initData.column.dropdownCheckAllList.push({
                        fieldEnName:item.key,
                        fieldZhName:item.title,
                        isVisiblity:true,
                        isFixed:false,
                    })
                    this.initData.column.dropdownCheckAllGroup.push(item.key);
                }
            });
            this.changeColumn();
            return;
        }
        if(this.$store.state.session.userHabits.ledger.specialContractLedger.length){
            this.initData.column.dropdownCheckAllList = this.$store.state.session.userHabits.ledger.specialContractLedger;
            this.$store.state.session.userHabits.ledger.specialContractLedger.forEach( (item:any) => {
                if(item.isVisiblity){
                    this.initData.column.dropdownCheckAllGroup.push(item.fieldEnName);
                }
            } )
            //设置全选按钮
            if (this.initData.column.dropdownCheckAllGroup.length === this.initData.column.dropdownCheckAllList.length) {
                this.initData.column.indeterminate = false;
                this.initData.column.checkAll = true;
            }else{
                this.initData.column.indeterminate = true;
                this.initData.column.checkAll = false;
            }
        }else{
            this.initData.tableData.title.forEach((item:any,index:any) => {
                if(index != 0){
                    this.initData.column.dropdownCheckAllList.push({
                        fieldEnName:item.key,
                        fieldZhName:item.title,
                        isVisiblity:true,
                        isFixed:false,
                    })
                    this.initData.column.dropdownCheckAllGroup.push(item.key);
                }
            });
        }
        this.changeColumn();
    }
    changeColumn(){ // 改变列
        let data:any = [this.initData.tableData.title[0]];
        this.initData.tableData.title.forEach( (item:any) => {
            this.initData.column.dropdownCheckAllGroup.forEach( (val:any) => {
                if(item.key == val){
                    data.push(item);
                }
            } )
        } )
        this.initData.tableData.newTitle = data;
    }
    //标注
    clickLabel(res:any){
        console.log(res)
        if(!this.initData.label.contractIds.length){
            this.$Message.error("请选择需要标记的合同！");
            return;
        }
        if(res == 'saveLabel'){
            this.initData.label.model = !this.initData.label.model;
        }else{
            this.$Modal.confirm({
                title: '批量删除标注',
                content: '是否批量删除勾选标注？',
                onOk: async () => {
                    await Ajax.post('/api/services/app/Contract/ContractRemoveLabelAsync',{contractIds:this.initData.label.contractIds,labelValue:this.initData.label.labelValue,});
                    this.GetData();
                    this.initData.label.contractIds = [];
                }
            });
        }
    }
    //单选
    singleChangeSel(selection:any){
       this.initData.label.contractIds = selection.map( (item:any) => {
            return item.id;
        } )
    }
    //保存标注
    async saveLabel(){
        await Ajax.post('/api/services/app/Contract/ContractAddLabelAsync',{contractIds:this.initData.label.contractIds,labelValue:this.initData.label.labelValue,});
        this.GetData();
        this.initData.label.contractIds = [];
    }
    //获取列表数据
    async GetData() {
        this.initData.tableData.loading = true;
        this.initData.searchData.SignYear = this.initData.searchData.SignYear ? this.initData.searchData.SignYear : undefined;
        let temp = (await Ajax.get('/api/services/app/Contract/GetAllSpecialByPagingAsync', {params: this.initData.searchData})).data.result;
        this.initData.tableData.content = temp.pageResult.items;
        this.initData.tableData.totalCount = temp.pageResult.totalCount;
        console.log(temp)
        //处理删选数据
        if(temp.statistic && temp.statistic.length){
            temp.statistic.map((item:any)=>{
                if(item.catalog == 1){
                    this.initData.tableData.statistic = item.auditStatusItems;
                }
            })
        }
        if(this.initData.tableData.content.length == 0){
            this.$Message.error('暂无数据！') 
        }
        this.initData.tableData.loading = false;
    }
    //合同切换
    SwitchContract(name:any) {
        this.$router.push({
            name: name
        })
    }
    //合同状态过滤
    FilterContract(type:any) {
        this.initData.tableData.currentIndex = type;
        this.initData.searchData.AuditStatus = type;
        this.GetData();
    }
    //合同详情
    ToDetail(e:any) {  
        (this as any).reloadComponent('contractSpecialDetail');
        this.$nextTick( () => {    
            this.$router.push({
                name: 'contractSpecialDetail',
                query: {
                    id: e.id
                }
            });
        } )   
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    //获取字典数据
    async GetDic() {
        //所有字典
        await this.$store.dispatch('project/GetAllDictionary');
        this.$store.state.project.allDictionary.map((item:any) => {
            this.initData.dicData[item.key] = item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            });
        })
        //部门字典
        if(!this.$store.state.project.bearerOrgId.length){
            await this.$store.dispatch('project/GetbearerOrg')    
        }
        //部门字典
        await this.$store.dispatch('project/GetContractBelongOrg');
        this.initData.dicData.bearerOrg = this.$store.state.project.contractBelongOrg;
        // this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgId;
        //获取当前用户权限
        await this.$store.dispatch('session/init');
        this.initData.showContractLabel = this.$store.state.user.userInfo.auth.grantedPermissions['Pages.CAndMManager.C.LabelMaintain'];
    }
    //合同登记选择类型弹窗-设置
    async GetContractType(type:any) {
        // await (this as any).$refs.ContractAddForm.GetDic();
        // this.initData.addModal.contractMainType = type;
        // this.initData.addModal.mainIsShow = true;
        
        this.initData.addModal.typeIsShow = false; 
        (this as any).reloadComponent('contractAdd');
        this.$nextTick( ()=>{
            this.$router.push({
                name: 'contractAdd',
                query: {
                    contractMainType: type
                }
            })
        } )   
    }
    //合同登记提交
    AddModalSubmit() {            
        (this as any).$refs.ContractAddForm.Submit();
    }
    //合同登记弹窗-关闭
    CloseAddModal(status:any){
        this.initData.addModal.mainIsShow = false;
    }
    //合同登记弹窗-关闭回调
    AddModalClose(status:any){
        this.initData.addModal.btnLoading = status;
    }
    //合同登记弹窗-关闭重置表单
    RestForm(status:any){
        (this.$refs.ContractAddForm as any).RestForm(status);
    }
    //导出
    Export() {
        (this as any).$root.Export(this.initData.searchData, '/api/ContractFile/ExportAllSpecialContractAsync', '外协合同台账', 'xlsx');
    }
    //初始化
    async mounted() {
        await this.GetDic();
        this.GetData();
        this.setDropdownCheckAllList();
    }
    activated(){
        this.initData.tabsBool = false;
        this.$nextTick(function () {
            this.initData.tabsBool = true;
        });
    }
}
